import React from 'react';
import AdminDashboard from './AdminDashboard';
import TeacherDashboard from './TeacherDashboard';

// Roles list (as of the org's current role set):
// STAKEHOLDER FEEDBACK, HO TEAM, SCHOOL APP SPOC, ADMIN, EVS & APP SPOC,
// SCHOOL EVS SPOC, PRINCIPAL, SCHOOL EVS SUB SPOC, APPROVER, SUBJECT TEACHER, SUPER ADMIN
//
// Only Subject Teachers get the Teacher Dashboard; every other role
// (Admin, Super Admin, HO Team, Principal, Approver, all SPOC variants,
// and any future role) falls back to the Admin Dashboard.
const isTeacherRole = (roleName) => roleName === 'SUBJECT TEACHER';

const Dashboard = () => {
  const roles = JSON.parse(localStorage.getItem('roles')) || [];
  const roleName = roles[0]?.name?.toUpperCase() || '';

  return isTeacherRole(roleName) ? <TeacherDashboard /> : <AdminDashboard />;
};

export default Dashboard;
